import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useState } from 'react';
import { Button } from '@/DesignSystem/Component';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { LINKS } from '@/Module/Core/Constant';
import MyAvatarDesktop from '@/Module/Profile/Component/MyAvatar/MyAvatarDesktop';
import { useAppDispatch } from '@/Module/Store/Hook';
import MiniAccountMenu from './MiniAccountMenu';
const MiniAccountLoggedInDesktop: FC = () => {
  const [isOpen, setOpen] = useState(false);
  const router = useRouter();
  const dispatch = useAppDispatch();
  const onClick = () => {
    if (`${router.pathname}/` !== LINKS.PROFILE.DEFAULT) {
      dispatch(authSetIsTransitioningAction(true));
      router.push(LINKS.PROFILE.DEFAULT);
    }
  };
  return <div className=" flex items-center xl:-ml-52" data-sentry-component="MiniAccountLoggedInDesktop" data-sentry-source-file="MiniAccountLoggedInDesktop.tsx">
      <Button onClick={onClick} size="small" className="whitespace-nowrap text-base font-medium text-blueSix" data-sentry-element="Button" data-sentry-source-file="MiniAccountLoggedInDesktop.tsx">
        <MyAvatarDesktop size="middle" data-sentry-element="MyAvatarDesktop" data-sentry-source-file="MiniAccountLoggedInDesktop.tsx" />
        پروفایل من
      </Button>
      <MiniAccountMenu isOpen={isOpen} setOpen={setOpen} data-sentry-element="MiniAccountMenu" data-sentry-source-file="MiniAccountLoggedInDesktop.tsx" />
    </div>;
};
export default MiniAccountLoggedInDesktop;